// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'user-plus';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M8.469 12.719a4.25 4.25 0 1 0 8.5 0 4.25 4.25 0 0 0-8.5 0zm4.25-2.125v4.25m-2.125-2.125h4.25m-13.813 0A4.784 4.784 0 0 1 7.69 8.32m-4.8-4.367a2.922 2.922 0 1 0 5.844 0 2.922 2.922 0 0 0-5.843 0z'
  />
);

export const viewBox = '0 0 18 18';
